import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Structure/Logic builder pages never unmount on navigation (SB is mounted
 * permanently in AppMainLayout, and switching between SB/LB or to any other
 * page is a regular in-app navigation, not just browser back/forward), so
 * modals rendered through a react-modal portal stay mounted — and visible
 * above whatever page you land on — unless closed explicitly. This closes
 * `onClose` whenever the route's pathname changes while the modal is open,
 * which covers both browser back/forward and in-app navigation.
 */
export var useCloseOnRouteChange = function (isOpen, onClose) {
    var pathname = useLocation().pathname;
    var onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;
    var isOpenRef = useRef(isOpen);
    isOpenRef.current = isOpen;
    var prevPathnameRef = useRef(pathname);
    useEffect(function () {
        if (prevPathnameRef.current === pathname)
            return;
        prevPathnameRef.current = pathname;
        if (isOpenRef.current) {
            onCloseRef.current();
        }
    }, [pathname]);
};
